import { render, staticRenderFns } from "./FtpDashboard.vue?vue&type=template&id=42846fee&scoped=true&"
import script from "./FtpDashboard.vue?vue&type=script&lang=js&"
export * from "./FtpDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FtpDashboard.vue?vue&type=style&index=0&id=42846fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42846fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VMain,VOverlay})
